import { useAtom } from 'jotai';
import React, { FunctionComponent } from 'react';

import { Box, Typography } from '@mui/material';

import {
  currentPageIndexSpecificSearchAtom,
  startRowSpecificSearchAtom,
  startRowGeneralSearchAtom,
  currentPageIndexGeneralSearchAtom,
} from '../utils/AtomConfig';
import { FileTable } from './FileTable';

export const SearchResult: FunctionComponent = () => {
  const [currentPageIndexSpecificSearch, setCurrentPageIndexSpecificSearch] =
    useAtom(currentPageIndexSpecificSearchAtom);
  const [startRowSpecificSearch, setStartRowSpecificSearch] = useAtom(
    startRowSpecificSearchAtom
  );
  const [currentPageIndexGeneralSearch, setCurrentPageIndexGeneralSearch] =
    useAtom(currentPageIndexGeneralSearchAtom);
  const [startRowGeneralSearch, setStartRowGeneralSearch] = useAtom(
    startRowGeneralSearchAtom
  );

  return (
    <Box>
      <Typography
        component='h2'
        variant='h6'
        sx={{ marginTop: 2, color: '#003591' }}
      >
        Results - By Title/Document Number
      </Typography>
      <FileTable
        useTemplateQuery={true}
        currentPageIndex={currentPageIndexSpecificSearch}
        onSetCurrentPageIndex={setCurrentPageIndexSpecificSearch}
        startRow={startRowSpecificSearch}
        onSetStartRow={setStartRowSpecificSearch}
        isSourceOfRefiners={true}
      ></FileTable>
      <Typography
        component='h2'
        variant='h6'
        sx={{ marginTop: 2, color: '#003591' }}
      >
        Results - By Context
      </Typography>
      <FileTable
        useTemplateQuery={false}
        currentPageIndex={currentPageIndexGeneralSearch}
        onSetCurrentPageIndex={setCurrentPageIndexGeneralSearch}
        startRow={startRowGeneralSearch}
        onSetStartRow={setStartRowGeneralSearch}
      ></FileTable>
    </Box>
  );
};
